import { API_ROOT, WEBSOCK_URL, ACCESS_API } from "../../urls";
import store from "../../../store";
import axiosmain from "axios";
import { reject } from "lodash";

export const sendLoginData = async loginData => {
  const url = `${API_ROOT}/api-token-auth/`;
  const { axios, ...login } = loginData;
  return axios.post(url, login);
};
export const sendRegistrationDataApiCall = registrationData => {
  const url = `${ACCESS_API}/register/`;
  return new Promise((resolve, reject) => {
    axiosmain
      .post(url, registrationData)
      .then(res => resolve(res))
      .catch(error => {
        store.dispatch("addNotification", {
          type: "errorMessage",
          message: `An error with status code ${error.response.status} has occured`
        });
        reject(error);
      });
  });
};

export const refreshToken = async axios => {
  const url = `${API_ROOT}/api-token-refresh/`;
  const token = await axios.post(url).then(res => res.data.token);
  return token;
};

export const getUserData = async ({ axios }) => {
  const url = `${API_ROOT}/users/user/`;
  const userData = await axios
    .get(url)
    .then(res => res.data)
    .catch(error => {
      store.dispatch("addNotification", {
        type: "errorMessage",
        message: `An error with status code ${error.response.status} has occured`
      });
    });
  return userData;
};

export const usernameRecovery = async email => {
  const url = `${API_ROOT}/accounts/recoverEmail/`;

  let userEmail = { email: email };
  const res = await axiosmain.post(url, { params: { userEmail } });
  return res;
  /*
  return new Promise((resolve) => {
    axios.post(url, userEmail)
      .then((res) => {
        const data = res.data
        resolve(data)
      })
      .catch(function (error) {
        console.error(error);
      })
  }) */
};

export const getToken = () => {
  return store.getters.getToken;
};

// export const isAuthenticated = () => {
//   console.log('checking authentcation');
//   const token = store.getters.getToken;
//   console.log('token', token);
//   return typeof(token) !== "undefined" && token !== null;

// };

export const getAuthentication = () => {
  return {
    headers: { Authorization: "JWT " + getToken() }
  };
};

export function  wsSend() {
  const ws = new  WebSocket(WEBSOCK_URL);
  console.log(ws);

  // Here is where the received message needs to dispatch
  // the data and maybe fire an event. After the received message is
  // stored, the wsSend must be called.

  ws.onmessage =  event => {
    console.log('message received:' + event.data);
  },

  // Send message to identify source of connection.
  ws.onopen = event => {
    const user = store.getters.getUser;
    console.log('user: ' + user.username);
    const msg = {route: 'handshake', name_id: user.username};
    ws.send(JSON.stringify(msg));
    console.log('message sent: ' + msg);
  },

  ws.onclose = event => {
    console.log(event)
    // Restarting
    wsSend()
  }
}
